import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import DesignCrmCarousel from "../../components/v4/designCarousel/DesignCarousel";
import industryIntegration from "../../images/v4/BussinessOwners/business.png";

import bussinessOwnerHeroImg from "../../images/v4/BussinessOwners/heroImg.png";
import BussinessOwnerpageHerobg from "../../images/v4/BussinessOwners/heroBg.png";
import salesCrmCarouselbg from "../../images/v4/salesReps/salesCarousel.svg";
import realWorldbg from "../../images/v4/salesReps/realWorld.svg";

import adaptImg1 from "../../images/v4/BussinessOwners/adaptImg/img1.svg";
import adaptImg2 from "../../images/v4/BussinessOwners/adaptImg/img2.svg";
import adaptImg3 from "../../images/v4/BussinessOwners/adaptImg/img3.svg";
import adaptImg4 from "../../images/v4/BussinessOwners/adaptImg/img4.svg";
import adaptImg5 from "../../images/v4/BussinessOwners/adaptImg/img5.svg";
import adaptImg6 from "../../images/v4/BussinessOwners/adaptImg/img6.svg";

import industryadaptbg from "../../images/v4/salesReps/clientAdapt.png";
import bussinessSuccessbg from "../../images/v4/BussinessOwners/integrationBg.png";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/salesReps/topcrm/zoho.png";
import compareItemImg3 from "../../images/v4/salesReps/topcrm/hubspot.png";
import compareItemImg4 from "../../images/v4/salesReps/topcrm/salesforce.png";
import compareItemImg5 from "../../images/v4/salesManagers/topcrm/insight.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import realWorldImage2 from "../../images/v4/BussinessOwners/realworld/img1.png";
import realWorldImage3 from "../../images/v4/BussinessOwners/realworld/img2.png";
import realWorldImage4 from "../../images/v4/BussinessOwners/realworld/img3.png";
import realWorldImage5 from "../../images/v4/BussinessOwners/realworld/img4.png";
import realWorldImage6 from "../../images/v4/BussinessOwners/realworld/img5.png";

import broadcastImg1 from "../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../images/v4/salesReps/Designfor/broadcast5.png";
import experienceImg1 from "../../images/v4/BussinessOwners/expericence/img1.png";
import experienceImg2 from "../../images/v4/BussinessOwners/expericence/img2.png";
import experienceImg3 from "../../images/v4/BussinessOwners/expericence/img3.png";
import experienceImg4 from "../../images/v4/BussinessOwners/expericence/img4.png";
import experienceImg5 from "../../images/v4/BussinessOwners/expericence/img5.png";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/client7.png";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";

const useStyles = makeStyles((theme) => ({
  BussinessOwnerSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${BussinessOwnerpageHerobg})`,
    padding: "40px 0 0",
    backgroundPosition: "center",
    borderRadius: "0 0 20px 20px",
    "@media only screen and (max-width: 1440px)": {
      backgroundPosition: "top",
      padding: "60px 0 0 ",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "120px 0 0",
      "& .centerContainer": {
        width: "90%",
        marginTop: "50px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "0",
      "& .centerContainer": {
        width: "95%",
        marginTop: "40px",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px 0 0",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
        gap: "20px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      padding: "0",
      "& .centerContainer": {
        marginTop: "20px",
        gap: "16px",
      },
    },
  },
  salesRepContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "20px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "32px",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      paddingTop: "20%",
      "& img": {
        transform: "translateY(1%)!important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      paddingTop: "0",
      maxWidth: "500px",
      "& img": {
        transform: "translateY(15%)!important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
    "& img": {
      transform: "translateY(18%)",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
        marginBottom: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "100px",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "0px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    marginBottom: "90px",
    "& h2": {
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& h2": {
        paddingRight: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
      marginTop: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      marginTop: "25px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "12px",
      marginTop: "15px",
    },
  },
  customerExperencesBox: {
    width: "32%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "50px",
    background: "#002c51",
    borderRadius: "15px",
    padding: "20px",
    minHeight: "230px",
    backdropFilter: "blur(30px) brightness(0.8)",
    overflow: "hidden",

    "& p:nth-child(2)": {
      color: "#D1E4F1",
    },
    "& p:last-child": {
      color: "#D1E4F1",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "31%",
      gap: "30px",
      padding: "18px",
      minHeight: "200px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "48%",
      gap: "25px",
      padding: "16px",
      minHeight: "180px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      padding: "15px",
      borderRadius: "20px",
      minHeight: "max-content",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      gap: "12px",
    },
    "&.orangeCard1": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard3": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard5": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard7": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard3": {
      background: "rgba(0, 154, 153, 0.4)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard0": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard2": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard4": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard6": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard7": {
      background: "#002C51",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  Client: {
    padding: "85px 0 40px",
    "& .client-carousel": {
      backgroundSize: "cover",
      backgroundImage: `url(${industryadaptbg})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      "@media only screen and (max-width: 768px)": {
        "& .logos-row": {
          height: "65px!important",
        },
      },
    },
    "& .header": {
      display: "flex",
      width: "33%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .body": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "60px 0",
      "& .header": {
        width: "40%",
      },
      "& .body": {
        marginTop: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "60px 0 20px",
      "& .header": {
        width: "60%",
      },
      "& .body": {
        marginTop: "30px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      "& .body": {
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "15px",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "streach",
      padding: "16px 8px",
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  integrationSection: {
    background: "linear-gradient(90deg, #09939A 0%, #783CA8 100%)",
  },
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  combineSection: {
    position: "relative",
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
    "@media only screen and (max-width: 768px)": {
      position: "static",
      transform: "translate(0, 0)",
    },
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "8px",
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",

    "& img": {
      width: "24px",
      height: "24px",
    },

    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  salesCrmCarousel: {
    backgroundImage: `url(${salesCrmCarouselbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "65px",
    "& .header-section": {
      flexDirection: "column",
      width: "55%",
      "& h2": {
        marginBottom: "20px",
      },
      "& p": {
        marginBottom: "15px",
      },
      "@media(max-width:768px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "60px",
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px",
      "& .header": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingBottom: "30px",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      color: "#1D6FB6",
      gap: "10px",
      "@media only screen and (max-width: 768px)": {
        marginBottom: "15px",
      },
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
    "& .exp-desc": {
      margin: "10px 0",
    },
  },

  accordianTabs: {
    paddingBottom: "300px",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "250px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "0",
    },

    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "40px",
      gap: "100px",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "40%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "18px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  realWorldTabs: {
    background: "linear-gradient(180deg, #E0EFFD 0%, #FFF 66.15%)",
    paddingTop: "300px",
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "65px 15px",
      "& .container": {
        padding: "0 15px ",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "40px 15px",
      "& .container": {
        padding: "0",
      },
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100%",
        },
      },
    },
  },
  clientDetails: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
    "& .header": {
      "@media only screen and (max-width: 768px)": {
        textAlign: "center",
        "& p": {
          width: "100%",
        },
      },
    },
  },
  adaptsBox: {
    gap: "24px",
    display: "flex!important",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    height: "auto!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "20px",
      maxWidth: "350px",
      gap: "14px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "18px",
      maxWidth: "320px",
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      maxWidth: "85%",
      gap: "10px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 1024px)": {
      minHeight: "70px",
    },
    "@media only screen and (max-width: 768px)": {
      minHeight: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
      minHeight: "auto",
    },
    "@media only screen and (max-width: 480px)": {
      minHeight: "auto",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
    "@media only screen and (max-width: 1024px)": {
      width: "44px",
      maxWidth: "44px",
      marginBottom: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "40px",
      maxWidth: "40px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "36px",
      maxWidth: "36px",
      marginBottom: "16px",
    },
    "@media only screen and (max-width: 480px)": {
      width: "32px",
      maxWidth: "32px",
      marginBottom: "14px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    padding: "15px 0",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },

  tabCardRightContainer: {
    width: "40%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      maxWidth: "500px",
      margin: "0 auto",
    },
  },

  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "8px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },
  faqBoxAccordian: {
    padding: "24px",
    backgroundColor: "#f8fcff",
    borderRadius: "16px",
    cursor: "pointer",
    "&.active": {
      backgroundImage: " linear-gradient(89deg, #e0effd 4%, #e0fafa 100%)",
    },
    "@media(max-width:768px)": {
      padding: "16px",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    cursor: "pointer",
    "&.noClick": {
      cursor: "not-allowed",
    },
    "& h3": {
      margin: "0",
    },
    "& img": {
      marginTop: "6px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#e9f4fe",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
}));

const experienceList = [
  {
    title: "One platform for complete business visibility",
    alt: "Multichannel CRM",
    lintText: "Multichannel CRM",
    linkUrl:
      "https://peppercloud.com/sales-crm-features/multichannel-integration-for-sales-marketing/",
    img: experienceImg1,
    desc: "Eliminate data silos and streamline access by consolidating client interactions, sales activity, and operational information in one secure platform.  With Pepper Cloud CRM, business owners and executives gain a complete overview of their organisation, empowering smarter decisions, faster responses, and better customer relationships, all from a single source of truth.",
  },
  {
    title: "Turn performance data into business growth",
    alt: "Dashboard and analytics",
    lintText: "Dashboard and analytics",
    linkUrl: "https://peppercloud.com/sales-dashboard/",
    img: experienceImg2,
    desc: "Make faster, smarter decisions with real-time access to key performance metrics, customer trends, and revenue insights. Pepper Cloud CRM empowers business leaders to identify opportunities, optimise strategies, and monitor progress effortlessly, ensuring every business move is backed by data and aligned with growth objectives.",
  },
  {
    title: "Automate operations with AI workflows",
    alt: "Assist AI",
    lintText: "Assist AI",
    linkUrl:
      "https://peppercloud.com/sales-crm-features/ai-crm-tool-for-small-business/",
    img: experienceImg3,
    desc: "Streamline daily operations by automating follow-ups, task assignments, and customer updates. Reduce manual intervention and ensure consistent execution across departments, helping business owners and executives focus on growth, strategy, and delivering exceptional customer experiences with fewer operational bottlenecks.",
  },
  {
    title: "Drive loyalty through better engagement",
    alt: "WhatsApp CRM",
    lintText: "WhatsApp CRM",
    linkUrl: "https://peppercloud.com/whatsapp-crm/",
    img: experienceImg4,
    desc: "Segment clients based on value, behaviour, or business goals to deliver more relevant experiences. Use automation to send personalised updates, reminders, and follow-ups at the right time. Build stronger trust, increase engagement, and retain high-value relationships that contribute to sustainable customer satisfaction and long-term business growth.",
  },
  {
    title: "Collaborate seamlessly from any location",
    alt: "Mobile CRM",
    lintText: "Mobile CRM",
    linkUrl: "https://play.google.com/store/apps/details?id=com.peppercloud",
    img: experienceImg5,
    desc: "Enable your teams and leadership to stay connected and productive on the go. With Pepper Cloud’s mobile-optimised CRM, access real-time business data, manage tasks efficiently, and respond to customer needs from any location, ensuring seamless collaboration, faster decision-making, and uninterrupted service delivery, wherever your business takes you.",
  },
];
const tabContentData = [
  {
    tabContent: [
      {
        heading: "Sales pipeline visibility",
        content: "Monitor deal stages, forecasts, and revenue trends",
      },
      {
        heading: "Team accountability",
        content:
          "Assign ownership, track performance, and ensure follow-through",
      },
      {
        heading: "Strategic oversight",
        content: "Access real-time insights to support faster decisions",
      },
      {
        heading: "Client relationship building",
        content:
          "Maintain long-term trust through consistent follow-ups and feedback",
      },
    ],
    image: realWorldImage2,
    alt: "Whatsapp CRM for eCommerce",
    subtitle:
      "Executives in fast-growing small to mid-sized businesses can use CRM to gain full visibility, streamline processes, and drive scale with limited resources.",
  },
  {
    tabContent: [
      {
        heading: "Centralised reporting",
        content: "Compare location-wise sales and service metrics",
      },
      {
        heading: "Role-based access",
        content: "Maintain data security while empowering local managers",
      },
      {
        heading: "Unified communication",
        content: "Standardise messaging across branches",
      },
      {
        heading: "Multi-location insights",
        content: "Identify top-performing branches and areas needing support",
      },
    ],
    image: realWorldImage3,
    alt: "Multi-location businesses",
    subtitle:
      "Owners managing multiple branches or regional teams can centralise operations, track location-specific performance, and ensure alignment from one platform.",
  },
  {
    tabContent: [
      {
        heading: "Client journey tracking",
        content: "View activity timelines, conversations, and feedback",
      },
      {
        heading: "Project pipeline",
        content: "Track deliverables, due dates, and touchpoints",
      },
      {
        heading: "Contract and renewal alerts",
        content: "Stay ahead with timely follow-ups",
      },
      {
        heading: "Time-saving automation",
        content: "Automate meeting reminders, reports, and feedback requests",
      },
    ],
    image: realWorldImage4,
    alt: "Franchise or partner-led organisations",
    subtitle:
      "  Executives in consulting, legal, or financial services can automate client handling, project tracking, and nurture high-value relationships at scale.",
  },
  {
    tabContent: [
      {
        heading: "Partner onboarding",
        content: "Automate documentation, training, and activation workflows",
      },
      {
        heading: "KPI dashboards",
        content: "Evaluate partner sales, performance, and compliance",
      },
      {
        heading: "Brand uniformity",
        content: "Share standardised templates, updates, and campaign assets",
      },
      {
        heading: "Franchise support",
        content:
          "Enable faster response to partner issues and performance gaps",
      },
    ],
    image: realWorldImage5,
    alt: "Investment-backed startups and scaleups",
    subtitle:
      "Founders and executive teams in investor-funded companies use CRM to demonstrate traction, streamline reporting, and accelerate growth without operational chaos.",
  },
  {
    tabContent: [
      {
        heading: "Investor reporting",
        content:
          "Share real-time dashboards on revenue, pipeline, and conversion metrics",
      },
      {
        heading: "Funnel clarity",
        content:
          "Track lead sources, deal velocity, and sales performance at each stage",
      },
      {
        heading: "Operational transparency",
        content:
          "Provide cross-team visibility for improved collaboration and output",
      },
      {
        heading: "Growth automation",
        content:
          "Scale outreach, client onboarding, and feedback loops effortlessly",
      },
    ],
    image: realWorldImage6,
    alt: "Investment-backed startups and scaleups",
    subtitle:
      "Founders and executive teams in investor-funded companies use CRM to demonstrate traction, streamline reporting, and accelerate growth without operational chaos.",
  },
];
const BussinessOwner = () => {
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const classes = useStyles();

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard3`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard2`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard0`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard4`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard6`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard1`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard5`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard7`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];
    const logotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
        case 2:
          logotrack3.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
      logotrack3,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  // client

  const allIconsclient = [
    {
      img: clientLogo1,
    },
    {
      img: clientLogo2,
    },
    {
      img: clientLogo3,
    },
    {
      img: clientLogo4,
    },
    {
      img: clientLogo5,
    },
    {
      img: clientLogo6,
    },
    {
      img: clientLogo7,
    },
  ];

  // Function to distribute icons across three tracks
  function clientdistributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) => a.img.localeCompare(b.img));

    const clientlogotrack1 = [];
    const clientlogotrack2 = [];
    const clientlogotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          clientlogotrack1.push(icon);
          break;
        case 1:
          clientlogotrack2.push(icon);
          break;
        case 2:
          clientlogotrack3.push(icon);
          break;
      }
    });

    return {
      clientlogotrack1,
      clientlogotrack2,
      clientlogotrack3,
    };
  }

  // Get the distributed icons
  const { clientlogotrack1, clientlogotrack2, clientlogotrack3 } =
    clientdistributeIcons(allIconsclient);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  // When the section is in view, set up a timer to auto change the active accordion every 5 seconds.
  useEffect(() => {
    let timer;
    if (inView) {
      timer = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, 5500);
    }
    // Clear the timer when the component unmounts or when inView changes.
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [inView, experienceList.length]);
  const benifitList = [
    {
      img: industryIntegration,
      title: "Why business owners need a powerful CRM",
      desc: "Business leaders need a CRM that simplifies operations, enhances visibility, and drives consistent growth. Pepper Cloud CRM delivers real-time insights, automation, and scalability, empowering owners and executives to focus on strategy. Whether managing teams or scaling markets, it ensures complete control with minimal effort and maximum efficiency.",
    },
  ];

  const faqs = [
    {
      question:
        "What is the best CRM for business owners and executives in 2025?",
      answer: (
        <>
          Pepper Cloud CRM is considered one of the best CRM platforms for
          business leaders due to its intuitive interface, real-time reporting,
          and leadership-focused automation tools.
        </>
      ),
    },
    {
      question:
        "What are the main benefits of CRM for business owners and executives?",
      answer: (
        <>
          The key benefits of CRM for business owners and executives include
          better visibility into operations, faster decision-making, improved
          team accountability, and stronger client relationships.
        </>
      ),
    },
    {
      question: "Can a CRM help executives with performance tracking?",
      answer: (
        <>
          Yes. Pepper Cloud CRM offers dashboards and analytics that provide
          insights into sales, team activities, and overall business
          performance, helping leaders make informed decisions.
        </>
      ),
    },
    {
      question: "Is CRM software suitable for small business owners?",
      answer: (
        <>
          Absolutely. Pepper Cloud is designed to be scalable, making it perfect
          for small business owners looking for growth, efficiency, and
          data-driven control.
        </>
      ),
    },
    {
      question: "How secure is the data in Pepper Cloud CRM?",
      answer: (
        <>
          Pepper Cloud ensures data privacy with enterprise-grade encryption,
          role-based access, and secure cloud storage to protect sensitive
          business information.
        </>
      ),
    },
    {
      question: "Can CRM be used to manage client and investor communications?",
      answer: (
        <>
          Yes. With segmentation tools and communication automation, Pepper
          Cloud helps you manage stakeholder relationships with precision and
          consistency.
        </>
      ),
    },
    {
      question: "Does Pepper Cloud integrate with tools I already use?",
      answer: (
        <>
          Yes. Pepper Cloud integrates with email, calendars, Google Drive,
          WhatsApp, and more, so you can work without switching platforms.
        </>
      ),
    },
    {
      question: "Is CRM only useful for sales teams?",
      answer: (
        <>
          Not at all. While it enhances sales, Pepper Cloud also supports
          executives in managing service quality, marketing ROI, and operational
          workflows.
        </>
      ),
    },
    {
      question: "How fast can a business owner get started with Pepper Cloud?",
      answer: (
        <>
          Most businesses can onboard within a few days, with ready-made
          templates and support to tailor the CRM to their exact needs.
        </>
      ),
    },
    {
      question:
        "Why is Pepper Cloud the best CRM for business owners and executives?",
      answer: (
        <>
          It’s flexible, powerful, and made for leadership. With deep insights,
          automation, and mobile access, Pepper Cloud empowers you to lead
          confidently in a fast-moving business world.
        </>
      ),
    },
  ];

  const adaptList = [
    {
      pointer: "Quick implementation",
      desc: "Set up your CRM in hours with pre-built modules tailored to business operations and decision-making workflows.",
      img: adaptImg1,
      alt: "Quick implementation",
    },
    {
      pointer: "Real-time insights",
      desc: "Track revenue, performance, and customer metrics with live dashboards for faster, smarter decisions.",
      img: adaptImg2,
      alt: "Real-time insights",
    },
    {
      pointer: "Workflow automation",
      desc: "Automate repetitive tasks, follow-ups, and approvals to increase team efficiency and reduce operational delays.",
      img: adaptImg3,
      alt: "Workflow automation",
    },
    {
      pointer: "Mobile accessibility",
      desc: "Manage your business, approve actions, and track performance securely—anytime, anywhere, from any device.",
      img: adaptImg4,
      alt: "Mobile accessibility",
    },
    {
      pointer: "Scalable architecture",
      desc: "Whether you're scaling locally or globally, the CRM evolves with your business and growth priorities.",
      img: adaptImg5,
      alt: "Scalable architecture",
    },
    {
      pointer: "Specialist assistance",
      desc: "Access 24/7 specialist support to maintain smooth operations and uninterrupted executive-level performance.",
      img: adaptImg6,
      alt: "Specialist assistance",
    },
  ];

  // sales rep contents
  const bannerPoints = [
    "Real-time dashboards for faster decisions",
    "Role-based access and permissions",
    "Automate workflows across all departments",
    "Centralised view of customer lifecycle",
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "Zoho CRM",
    "HubSpot CRM",
    "Salesforce CRM ",
    "Insightly CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: " Pepper Cloud is the best CRM for business owners and executives. It offers real-time dashboards, powerful automation, and deep insights to help leaders make informed decisions and scale operations.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Visual analytics",
          desc: "Track sales, performance, and team KPIs in one place",
        },
        {
          title: "Process automation",
          desc: "Eliminate repetitive tasks and standardise workflows",
        },
        {
          title: "Mobile access",
          desc: "Manage your business on the go",
        },
        {
          title: "Scalable design",
          desc: "Grows with startups, SMEs, and large enterprises",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "A budget-friendly CRM solution for growing businesses. Offers automation tools and flexible modules suitable for cross-functional collaboration.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Customisable dashboards",
          desc: "Dashboard layout and content can be customised as per the user requirements to show preferred data.",
        },
        {
          title: "Third-party integrations",
          desc: "Connects with applications such as email, accounting software, and marketing tools for unified data.",
        },
        {
          title: "Workflow and lead management",
          desc: "Sorts and assigns leads automatically, triggering follow-up reminders or actions. ",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: " Great for small business owners starting with CRM. Simple interface with marketing, sales, and service tools all in one free-to-start platform.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Sales pipeline tracking",
          desc: "Tracks each deal through its sales stages, showing progress and potential bottlenecks.",
        },
        {
          title: "Contact segmentation",
          desc: "Categorises customers into groups based on attributes like location or purchase history.",
        },
        {
          title: "Email and live chat integration",
          desc: "Consolidates customer communication channels into one platform for easier tracking.",
        },
      ],
    },
    {
      title: "Salesforce CRM",
      desc: "Enterprise-grade CRM for executives who need advanced analytics, AI insights, and integration with large-scale ecosystems.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Custom apps and reporting",
          desc: "Allows creation of tailored tools and detailed analytical reports to fit specific processes.",
        },
        {
          title: "AI-based forecasting",
          desc: "Uses predictive analytics to estimate sales performance and future demand.",
        },
        {
          title: "Automation across sales and service",
          desc: "Standardises and automates tasks so data stays consistent across departments. ",
        },
      ],
    },
    {
      title: "Insightly CRM",
      desc: "Ideal for service-focused businesses looking to align projects, sales, and customer data within one unified platform.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Built-in project management",
          desc: "Provides tools to assign tasks, set deadlines, and track project milestones within the CRM.",
        },
        {
          title: "Email tracking",
          desc: "Records when an email is opened or when a recipient clicks a link.",
        },
        {
          title: "Performance dashboards",
          desc: "Offers visual overviews of metrics like sales, productivity, or project status.",
        },
      ],
    },
  ];
  const broadcastList = [
    {
      pointer: "CRM for sales managers",
      card: {
        pointer: [
          "Track sales performance, coach teams better, and scale revenue with real-time insights and reports.",
        ],
        img: broadcastImg1,
        alt: "Create whatsapp broadcast list",
        backgroundColor: "#f48446",
        backgroundImage: "linear-gradient(to bottom, #f48446, #783ca8)",
      },
    },
    {
      pointer: "CRM for sales development reps",
      card: {
        pointer: [
          "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
        ],
        img: broadcastImg2,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: "#014957",
        backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
      },
    },
    {
      pointer: "CRM for marketing teams",
      card: {
        pointer: [
          "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
        ],
        img: broadcastImg3,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: " #31114b",
        backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8);",
      },
    },
    {
      pointer: "CRM for customer support teams",
      card: {
        pointer: [
          "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
        ],
        img: broadcastImg4,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#2788e7",
        backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
      },
    },
    {
      pointer: "CRM for business owners",
      card: {
        pointer: [
          "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
        ],
        img: broadcastImg5,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#09939a",
        backgroundImage: " linear-gradient(to bottom, #09939a, #783ca8)",
      },
    },
  ];

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <main>
      <SEO
        description={
          "Discover how Pepper Cloud CRM helps business owners and executives gain visibility, drive growth, and make data-driven decisions across every team."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="crm for business owners and executives, best crm for business owners and executives, benefits of crm for business owners and executives"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={"CRM for business owners and executives | Pepper Cloud"}
      />

      <section className={classes.BussinessOwnerSection}>
        <div className="container">
          <div className={classes.salesRepContainer}>
            <div className={classes.salesSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                CRM for business owners
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white bannerDescription"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Streamline decisions, align teams, and accelerate business
                growth with powerful CRM insights.
              </motion.p>
              <div className={classes.bannerPoint}>
                {bannerPoints.map((point) => (
                  <div className={classes.banerPointItem}>
                    <img src={bannerTick} />
                    <motion.p
                      className="font-wix-regular font-18 font-white"
                      key={`banner-point-${point}`}
                    >
                      {point}
                    </motion.p>
                  </div>
                ))}
              </div>

              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <motion.div
              className={classes.aiSectionRight}
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <LazyImage
                alt={"WhatsApp CRM"}
                source={bussinessOwnerHeroImg}
                width={"100%"}
              />
            </motion.div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <div className={classes.clientDetails}>
            <div className="header">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Trusted by top brands across industries
              </motion.h2>
            </div>
            <div className="client-carousel">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {clientlogotrack1.map((logo) => (
                        <div
                          className="logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {clientlogotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {clientlogotrack3.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {benifitList.map((benifit) => (
        <section className={classes.integrationSection}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <div className={classes.integrationLeft}>
                <motion.h2
                  className="font-wix-semibold font-56 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.title}
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 font-white mt20"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.desc}
                </motion.p>
              </div>
              <div className={classes.integrationRight}>
                <motion.img
                  alt={benifit.title}
                  className={classes.integrationRightImage}
                  initial={{ opacity: 0, y: -80 }}
                  src={benifit.img}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.2 }}
                  whileInView={{ opacity: 1, y: 0 }}
                />
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="header-section">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              What leaders expect from CRM
            </motion.h2>
            <motion.p
              className="font-wix-regular font-18 color-black2"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Business leaders require a CRM that simplifies operational
              oversight, strengthens team collaboration, centralises customer
              data, and delivers clear visibility across departments to support
              faster, smarter decision-making.
            </motion.p>
          </div>
        </div>
        <Swiper
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1,
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              slidesPerGroup: 1,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
          }}
          className={classes.adaptSlider}
          grabCursor={true}
          loop={true}
          modules={[Autoplay]}
          speed={5000}
          slidesPerView={"auto"}
          // centeredSlides={true}
          spaceBetween={30}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  // alt={point.card.alt}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold lineHeight-1">
                  {point.pointer}
                </p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.experienceContainer} ref={ref}>
        <section className={classes.accordianTabs}>
          <div className="container">
            <div className="headercenterContainer">
              <motion.h2
                className="font-wix-semibold font-56 text-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Why Pepper Cloud is the best CRM solution
              </motion.h2>
              <p className="font-18 font-wix-regular text-black2">
                Pepper Cloud CRM is purpose-built for business owners and
                executives who need clarity, control, and scalability. It
                simplifies operations, offers real-time visibility, and empowers
                leadership to make high-impact decisions. Whether managing a
                lean team or scaling across markets, Pepper Cloud ensures you
                stay informed, agile, and growth-ready at every stage.
              </p>
            </div>
            <div className={classes.experienceInnerContainer}>
              <div className={classes.experienceContainerLeft}>
                {experienceList.map((faq, index) => (
                  <motion.div
                    key={index}
                    className={clsx(
                      classes.faqBoxAccordian,
                      activeAccordian === index && "active",
                      "text-color2"
                    )}
                    onClick={() => {
                      if (activeAccordian !== index) {
                        setActiveAccordian(index); // only switch if different
                      }
                    }}
                  >
                    <div
                      className={clsx(
                        classes.experienceHeader,
                        activeAccordian === index && "noClick"
                      )}
                    >
                      <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                      <img
                        alt="Arrow"
                        className={clsx(
                          classes.downArrow,
                          activeAccordian === index && "active"
                        )}
                        src={downArrow}
                      />
                    </div>

                    <Collapse
                      className={classes.body}
                      in={activeAccordian === index}
                    >
                      <p className="font-18 font-wix-regular color-black2 exp-desc">
                        {faq.desc}
                      </p>
                      <a
                        className="font-18 font-wix-regular view-more-link"
                        href={faq.linkUrl}
                      >
                        {faq.lintText}{" "}
                        <img alt="Arrow Right" src={arrowRight} />{" "}
                      </a>
                      <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={faq.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    </Collapse>
                  </motion.div>
                ))}
              </div>
              <div className={classes.experienceContainerRight}>
                {experienceList.map(
                  (experience, index) =>
                    index === activeAccordian && (
                      <motion.img
                        initial={{ opacity: 1, y: 20 }}
                        src={experience.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    )
                )}
              </div>
            </div>
          </div>
          <div className={classes.absoulteCard}>
            <TruestedSection background={true} />
          </div>
        </section>

        <section className={classes.realWorldTabs}>
          <div className="container">
            <div className="centerContainer">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Application and use cases of CRM software
              </motion.h2>
              <div className={classes.tabsContainer}>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 0 && "active"
                  )}
                  onClick={() => setActiveRealWorld(0)}
                >
                  Fast-growing SMEs
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 1 && "active"
                  )}
                  onClick={() => setActiveRealWorld(1)}
                >
                  Multi-location businesses
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 2 && "active"
                  )}
                  onClick={() => setActiveRealWorld(2)}
                >
                  B2B service companies
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 3 && "active"
                  )}
                  onClick={() => setActiveRealWorld(3)}
                >
                  Franchise
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 4 && "active"
                  )}
                  onClick={() => setActiveRealWorld(4)}
                >
                  Startups
                </div>
              </div>
            </div>

            <div className={classes.tabCard}>
              <div className={classes.tabCardLeftContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <div>
                        <motion.p
                          className="font-wix-regular font-18 color-black2"
                          initial={{ opacity: 0, y: 20 }}
                          transition={{ duration: 0.3 }}
                          whileInView={{ opacity: 1, y: 0 }}
                        >
                          {listItem.subtitle}
                        </motion.p>
                        <div className={classes.benfitListContainer}>
                          {listItem.tabContent.map((item) => (
                            <motion.div
                              className={classes.benfitListItem}
                              initial={{ opacity: 0, y: 20 }}
                              transition={{ duration: 0.3 }}
                              whileInView={{ opacity: 1, y: 0 }}
                            >
                              <LazyImage
                                alt={item.alt}
                                className={classes.benfitIcon}
                                source={bannerTick}
                              />
                              <div className={classes.benfitListItemContent}>
                                <p className="font-wix-semibold font-20 color-black1">
                                  {item.heading}
                                </p>
                                <p className="font-wix-regular font-18 color-black2">
                                  {item.content}
                                </p>
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      </div>
                    )
                )}
              </div>
              <div className={classes.tabCardRightContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <motion.div
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        // className={classes.aiSectionRight}
                      >
                        <LazyImage
                          alt={listItem.alt}
                          source={listItem.image}
                          width={"100%"}
                        />
                      </motion.div>
                    )
                )}
              </div>
            </div>
          </div>
        </section>
      </section>

      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccesSection}>
          <div className={classes.bussinessSuccessContainer}>
            <div className={classes.integrationHeaderItem}>
              <div className={classes.integrationContent}>
                <motion.p
                  className="font-wix-semibold font-20 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Features
                </motion.p>
                <motion.h2
                  className="font-wix-semibold font-56 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Tailored for business success
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  The best CRM for sales reps who want to streamline their sales
                  process, stay organised, and win more deals.
                </motion.p>
              </div>
            </div>

            <section className="bussiness-logo-carousel">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div
                          className="logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {logotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack3.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="header">
          <motion.h2
            className="font-wix-semibold font-56 font-black1"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Top 5 simple CRM platforms for business in 2025
          </motion.h2>
        </div>
        <div className={classes.compareSectionContainer}>
          <div className={classes.compareSectionContainerLeftSection}>
            {compareItems.map((item, index) => (
              <div
                className={clsx(
                  classes.compareSectionLeftItem,
                  activeCompare === `#section${index}` && "active"
                )}
                onClick={() => {
                  scrollToSection(`#section${index}`);
                  setActiveCompare(`#section${index}`);
                }}
              >
                <a
                  className={clsx(
                    "font-22 font-wix-medium font-black1",
                    activeCompare === `#section${index}` && "font-wix-semibold"
                  )}
                  href={`#section${index}`}
                >
                  {item}
                </a>
              </div>
            ))}
          </div>
          <div className={classes.compareSectionContainerRightSection}>
            {compareData.map((data, outerIndex) => (
              <div
                className={classes.compareItemContainer}
                id={`#section${outerIndex}`}
              >
                <h3
                  className="font-40 font-wix-semibold font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.title}
                </h3>
                <p
                  className="font-wix-regular font-18 font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.desc}
                </p>
                <img alt={data.alt} className="productImage" src={data.img} />
                <div className={classes.faqsContainer}>
                  {data.features.map((faq, innerIndex) => (
                    <motion.div
                      className={classes.faqBox}
                      onClick={() =>
                        setActiveAccordian(
                          `${outerIndex}-${innerIndex}` === activeAccordian
                            ? -1
                            : `${outerIndex}-${innerIndex}`
                        )
                      }
                      transition={{ duration: 1, delay: innerIndex * 0.01 }}
                      whileInView={{ opacity: [0, 1], y: [50, 0] }}
                    >
                      <div className={classes.topFiveHeader}>
                        <h3 className="font-20 font-wix-semibold">
                          {faq.title}
                        </h3>
                        <img
                          alt="Arrow"
                          className={clsx(
                            classes.downArrow,
                            `${outerIndex}-${innerIndex}` === activeAccordian &&
                              "active"
                          )}
                          src={downArrow}
                        />
                      </div>
                      <Collapse
                        className={classes.body}
                        in={activeAccordian === `${outerIndex}-${innerIndex}`}
                      >
                        <p className="font-18 font-wix-regular color-black2">
                          {faq.desc}
                        </p>
                      </Collapse>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          faqs={faqs}
          heading={
            "Best CRM for business owners - Frequently Asked Questions (FAQs)"
          }
        />
      </div>
      <DesignCrmCarousel backgroundImage={""} bgColor={"#e9f4fd"} />
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Lead smarter, grow faster with Pepper Cloud
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BussinessOwner;
